import { render, staticRenderFns } from "./SinotticoQuickConnext.vue?vue&type=template&id=70337472&"
import script from "./SinotticoQuickConnext.vue?vue&type=script&lang=js&"
export * from "./SinotticoQuickConnext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports